/**
 * Castle codes: 4 letters players type to join (e.g. "RAVN").
 * Excludes letters that are easy to confuse when read off a TV across a room
 * (I/L, O/Q). Collisions with live castles are checked by the server.
 */
export const CASTLE_CODE_ALPHABET = "ABCDEFGHJKMNPRSTUVWXYZ";
export const CASTLE_CODE_LENGTH = 4;
const CODE_PATTERN = new RegExp(`^[${CASTLE_CODE_ALPHABET}]{${CASTLE_CODE_LENGTH}}$`);
/** Words we never want shown on a family TV. Checked against generated codes. */
const BLOCKED_CODES = new Set([
    "ANUS", "ARSE", "CUNT", "DAMN", "DICK", "DYKE", "FUCK", "HELL", "JAPS",
    "KKKK", "NAZI", "PAKI", "PRAT", "PUSS", "SHAG", "SHIT", "SLAG", "SPAZ",
    "TWAT", "WANK", "XXXX",
]);
export function generateCastleCode(random = Math.random) {
    for (;;) {
        let code = "";
        for (let i = 0; i < CASTLE_CODE_LENGTH; i++) {
            code += CASTLE_CODE_ALPHABET[Math.floor(random() * CASTLE_CODE_ALPHABET.length)];
        }
        if (!BLOCKED_CODES.has(code))
            return code;
    }
}
/** Upper-cases, trims and strips spaces so "ravn " and "r a v n" both work. */
export function normaliseCastleCode(input) {
    return input.replace(/\s+/g, "").toUpperCase();
}
export function isValidCastleCode(input) {
    return CODE_PATTERN.test(normaliseCastleCode(input));
}
//# sourceMappingURL=codes.js.map